<template>
    <div>
        <Vue3Html2pdf 
        :show-layout="false"
        :float-layout="true"
        :enable-download="false"
        :preview-modal="false"
        :pdf-quality="1"
        :manual-pagination="true"
        :html-to-pdf-options="htmlToPdfOptions"
        pdf-format="a5"
        pdf-orientation="landscape"
        pdf-content-width='100%'
        @beforeDownload="beforeDownload($event)"
        ref="html2Pdf">
            <template #pdf-content>
                <!-- <Breadcrumbs main="Estimator" title="default" /> -->
                <div class="bg-me-primary border-color-light width-100-p">
                    <h3 class="text-white mt-3 ml-1">Home</h3>
                    <div class="container-fluid p-0">
                        <div class="row widget-grid">
                            <el-row span="24" :class="$vuetify.display.width < 750 ? 'm-0 width-100-p m-t-4' : 'm-0 width-100-p m-t-8'" >
                                    <!-- Abatement -->
                                    <el-col
                                    class="d-flex align-item-center px-2"
                                    :span="$vuetify.display.width >= 1500 ? 16 : 24"
                                    >
                                    <div
                                        class="row m-0 bg-me-primary border-color-light width-100-p rounded-4 d-flex flex-row flex-wrap"
                                        :style="$vuetify.display.width >= 1500 ? '' : 'padding-bottom: 30px'"
                                    >
                                        <el-col :span="24"
                                        :style="'padding: 20px;'"
                                        >
                                        <h5 class="text-white mt-3 ml-1">Abatement (tCO2-e)</h5>
                                        </el-col>
                                        <!-- Abatement Chart -->
                                        <el-col
                                        v-loading="loadingChart"

                                        :style="$vuetify.display.width >= 700
                                            ? {
                                                flex: '2',
                                                minWidth: '600px',
                                                maxWidth: '1000px',
                                            } : {
                                                flex: '2',
                                                minWidth: '350px',
                                                maxWidth: '100%',
                                        }"
                                        >
                                        <div id="chart" v-if="!loadingChart">
                                            <apexchart
                                            :key="chartKey"
                                            type="line"
                                            height="350"
                                            :options="localAbatementOptions"
                                                :series="localAbatementSeries"
                                            ></apexchart>
                                        </div>
                                        <!-- <newChart /> -->
                                        </el-col>
                                        <!-- Abatement Card -->
                                        <el-col
                                        class="y-center"

                                                :style="{
                                                flex: '1',
                                                minWidth: '300px',
                                                maxWidth: '500px',
                                                paddingBottom: '30px',
                                            }"
                                        ><AbatementCard :dataProp="localDataProp" />
                                    </el-col>
                                        
                                    </div>
                                    </el-col>
                                    <!-- History -->
                                    <el-col
                                    class="d-flex align-item-center px-2"
                                    :span="$vuetify.display.width >= 1500 ? 8 : 24"
                                    :class="$vuetify.display.width < 1500 ? 'mt-20' : ''"
                                    >
                                    <div
                                        class="row m-0 bg-me-primary border-color-light width-100-p rounded-4"
                                    >
                                        <el-col 
                                        :span="24" 
                                        :style="'margin: 20px'"
                                        >
                                        <h5 class="text-white mt-3 ml-1"  >Abatement history</h5>
                                        <el-text tag="sub" size="small" class="pl-2 text-white">
                                            <li class="fa fa-refresh font-13 mr-2" ></li>
                                            Last Update : {{ lastUpdateAbatement }}
                                        </el-text>
                                        </el-col>
                                        <el-col :span="24">
                                        <div id="chart" v-if="!loadingHistoryChart">
                                            <apexchart
                                            :key="chartKey"
                                            type="bar"
                                            height="350"
                                            :options="localHistoryOptions"
                                            :series="localHistorySeries"
                                            ></apexchart>
                                        </div>
                                        </el-col>
                                    </div>
                                    </el-col>
                                </el-row>
                            <DashboardCard :dataProp="localDataProp" />
                    </div>
                </div>
                </div>
            </template>
        </Vue3Html2pdf>
    </div> 

</template>

<script>


import Vue3Html2pdf from "vue3-html2pdf";
import AbatementCard from "./abatementCard.vue";
import DashboardCard from "./dashboardCard.vue";
// import Filter from "../common/filter.vue";


export default {

    computed: {
        // data from store for total tables
        // ...mapState('estimator', {
        //     estimatorData: state => state.estimatorData
        // }),
    },
    data(){
        return {

            localAbatementOptions: null, // Local copy of options
            localAbatementSeries: null,  // Local copy of series
            localHistoryOptions: null, // Local copy of options
            localHistorySeries: null,  // Local copy of series
            localDataProp: null, 

            htmlToPdfOptions: {
                filename:"Home",
                
                html2canvas: {
                    scale: 2,
                    useCORS: false,
                    removeContainer: true,
                    foreignObjectRendering: true, // fixed issue with incorrect legend text color
                    imageTimeout: 0,
                },

                jsPDF: {
                    unit: "px", // Use pixels for unit
                    format: [2250, 1587], // Set the width to 2250px and height proportionally
                    orientation: "landscape",
                },
            }
        }
    },

    watch: {
        options: {
            handler(newValue) {
                this.localAbatementOptions = newValue; // Update localOptions when options prop changes
            },
            immediate: true, // Ensure the local copy is initialized on component mount
            deep: true,
            },
        series: {
            handler(newValue) {
                this.localAbatementSeries = newValue; // Update localSeries when series prop changes
            },
            immediate: true,
            deep: true,
            },
        optionsHistory: {
            handler(newValue) {
                this.localHistoryOptions = newValue; // Update localOptions when options prop changes
            },
            immediate: true, // Ensure the local copy is initialized on component mount
            deep: true,
            },
        seriesHistory: {
            handler(newValue) {
                this.localHistorySeries = newValue; // Update localSeries when series prop changes
            },
            immediate: true,
            deep: true,
        },
        dataProp: {
            handler(newValue) {
                this.localDataProp = newValue; // Update localDataProp when dataProp prop changes
            },
            immediate: true,
            deep: true,
        },
    },

    props: {
        options: {
        type: Object,
        default: () => ({}),
        },
        series: {
        type: Array,
        default: () => [],
        },
        optionsHistory: {
        type: Object,
        default: () => ({}),
        },
        seriesHistory: {
        type: Array,
        default: () => [],
        },
        dataProp: {
        type: Array,
        default: () => [],
        },
    },
    components: {
        Vue3Html2pdf,
        // estimaOutput,
        AbatementCard,
        DashboardCard,
        // Filter,

    },
    methods: {




        async beforeDownload({html2pdf, options, pdfContent }){
            // console.log("Before download event", html2pdf, options, pdfContent);

            
            try {
            

                await this.$nextTick();

                await html2pdf().set(options).from(pdfContent).toPdf().get('pdf').then(() => {
                
                    // let totalPages = pdf.internal.getNumberOfPages();

                    // delete the last page of the pdf to remove two buttons
                    // pdf.deletePage(totalPages);
                    
                }).save();

                // console.log("single scenario PDF  save successfully");

                // this.removeFixedWidth();

                

            } catch (error) {
                console.error("Error during single scenario PDF generation:", error);
            }
            
            
        },

        async generateReport() {

            try {
                // await this.$nextTick(); // make sure dom updated
                await this.$refs.html2Pdf.generatePdf();

                // console.log("single scenario PDF generated successfully");

            } catch(error) {
                console.error(error);
            }
            
        },
    },
 

}



</script>

<style scoped>
span{
    color: white;
}

.pdf-content {
  width: 2250px !important;
  max-width: 2250px !important;
  margin: 0 auto !important;
  overflow: hidden !important;
}



.bg-me-primary {
  width: 2250px !important;
  max-width: 2250px !important;
  margin: 0 auto !important;
}

.width-100-p {
  width: 2250px !important;
  max-width: 2250px !important;
}

/* .fixed-width .bg-me-primary,
.fixed-width .output,
.fixed-width .output * {
  width: 1700px !important; 
} */

</style>

